module.exports = "../../static/img/play_btn.e8add23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/play_btn.png
// module id = wuQs
// module chunks = 1